import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Seo } from "@/components/common/Seo";
import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { SectionLabel } from "@/components/common/SectionLabel";
import { SEO } from "@/data/site";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Blog() {
  const [posts, setPosts] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    axios.get(`${API}/articles`)
      .then((r) => setPosts(r.data || []))
      .catch(() => {})
      .finally(() => setLoaded(true));
  }, []);

  return (
    <>
      <Seo title={SEO.blog.title} description={SEO.blog.description} />
      <PageHero
        label="Insights"
        titleLines={["Notes on", "Advertising."]}
        accentIndex={1}
        subtitle="Thinking on transparent DOOH, per-impression billing, and the future of residential advertising."
      />
      <section className="bg-paper py-24 md:py-32">
        <div className="container-px">
          <Reveal><SectionLabel>Latest</SectionLabel></Reveal>
          {loaded && !posts.length && (
            <Reveal delay={0.05}>
              <p className="mt-12 text-ink/50 text-lg" data-testid="blog-empty">Fresh thinking is on the way — the first notes publish soon.</p>
            </Reveal>
          )}
          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6">
            {posts.map((p, i) => (
              <Reveal key={p.slug} delay={i * 0.08}>
                <Link to={`/insights/${p.slug}`} data-testid={`article-card-${p.slug}`}
                  className="group h-full block bg-white border border-ink/10 rounded-xl overflow-hidden transition-transform duration-300 hover:-translate-y-1">
                  {p.cover_image && (
                    <img src={p.cover_image} alt={p.title} className="w-full h-44 object-cover border-b border-ink/10" />
                  )}
                  <div className="p-8">
                  <div className="flex items-center justify-between">
                    <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-teal">{p.tag}</span>
                    <span className="font-mono text-xs text-ink/40">{p.read}</span>
                  </div>
                  <h3 className="mt-6 font-display font-700 text-2xl leading-snug">{p.title}</h3>
                  <p className="mt-4 text-ink/60 leading-relaxed">{p.excerpt}</p>
                  <span className="mt-6 inline-flex items-center gap-2 font-display font-600 text-ink group-hover:text-teal transition-colors">
                    Read article <ArrowUpRight className="h-4 w-4" />
                  </span>
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
